module.exports = __webpack_public_path__ + "static/lifetimeUI-079fc6b424fe3f2bb2ada223e84c8ed0.jpg";